<table class="table is-fullwidth is-hoverable">
  <thead>
  </thead>
  <tbody>
    {#each items as item}
      <tr>
        <td>
          <div class="is-pulled-left" style="width:120px; height:120px; margin-right:20px;">
            <a href={$url('../need/' + item.id)} style="display:inline-block;width:120px;">
            {#if item.data.images?.[0]}
              <img
                alt="item"
                src={item.data.images[0]}
                style="max-height:120px;max-width:120px;" />
            {:else}
              <img
                alt="generic item"
                src="/assets/img/box.png"
                style="height:120px;width:120px; background-color:#eee" />
            {/if}
          </a>
          </div>
          <div>
            <a href={$url('../need/' + item.id)}>{item.data.title}</a>
          </div>
          <div class="is-line-clamp-4">{item.data.charityDetails ? item.data.charityDetails.name : ''}</div>
        </td>
      </tr>
    {/each}
  </tbody>
</table>

<script lang="ts">
  export let items :any[];

  import { url } from "@sveltech/routify";
</script>